<template>
    <v-dialog v-model="show" max-width="400" scrollable persistent no-click-animation>\
        <div class="CustomerPropertyCreator">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('addNew') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" ref="form" class="dialog-content">
                <div class="label">{{ $f.tc('key') }}</div>
                <v-text-field
                    v-model="model.name"
                    :rules="[formRules.ruleRequired, formRules.ruleKeyFormat, checkKeyExisted.bind(this, -1)]"
                    class="input-custom"
                ></v-text-field>
                <div class="label">{{ $f.tc('title') }}</div>
                <v-text-field
                    v-model="model.description"
                    :rules="[formRules.ruleRequired, checkTitleExisted.bind(this, -1)]"
                    class="input-custom"
                ></v-text-field>
            </v-form>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'

export default {
    name: 'CustomerPropertyCreator',
    mixins: [
        DialogPromiseFormMixin
    ],
    props: {
        uniqueEditable: {
            type: Boolean,
            default: true
        },
        propertyList: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            formAddValid: false,
            model: {
                name: '',
                description: ''
            }
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    methods: {
        submitValidForm () {
            this.close()
            this.promise.resolve(this.model)
        },
        checkKeyExisted (ignoreIndex, value) {
            for (let property of this.propertyList) {
                if (value === property.name) {
                    return 'Key existed'
                }
            }
            return true
        },
        checkTitleExisted (ignoreIndex, value) {
            for (let property of this.propertyList) {
                if (value === property.description) {
                    return 'Title existed'
                }
            }
            return true
        }
    }
}
</script>
<style scoped lang="scss">
.CustomerPropertyCreator {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;
    width: 100%;

    .btn-custom {
        margin-right: 8px !important;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }
}


.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }
}
</style>
